import { Maybe, MaybeUndef } from 'types/UtilityTypes';

type FreightClassAutoApplyArgs = {
  currentFreightClass: MaybeUndef<string>;
  densityDerivedFreightClass: MaybeUndef<string>;
  isFreightClassLocked: boolean;
};

function normalizeFreightClass(value: MaybeUndef<string>): string {
  return value?.trim() ?? '';
}

export function getThreeGFreightClassAutoApplyUpdate({
  currentFreightClass,
  densityDerivedFreightClass,
  isFreightClassLocked,
}: FreightClassAutoApplyArgs): Maybe<string> {
  const current = normalizeFreightClass(currentFreightClass);
  const densityDerived = normalizeFreightClass(densityDerivedFreightClass);

  if (isFreightClassLocked || densityDerived === '') {
    return null;
  }

  if (current === densityDerived) {
    return null;
  }

  return densityDerived;
}
